import { I18n } from '~/src/helpers/i18n';

(function () {
  const i18n = new I18n('', translations)
  const setTranslationContext = i18n.setContext.bind(i18n)
  t = i18n.t.bind(i18n)
  
  window.t = t
  window.setTranslationContext = setTranslationContext
})()


